import React from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'

const styles = {
  td: {
    padding: '4px 28px',
    whiteSpace: 'nowrap',
    textAlign: 'center',
  },
}

const Td = ({ classes, children, className, ...otherProps }) => (
  <td {...otherProps} className={classNames(classes.td, className)}>
    {children}
  </td>
)

export default injectStyles(styles)(Td)



// WEBPACK FOOTER //
// ./src/Components/Stats/Table/Td.js